import { useEffect } from 'react';

const GTM_ID = process.env.REACT_APP_GTM_ID;

export default function GoogleTagManager() {
  useEffect(() => {
    if (!GTM_ID) return;
    if (document.querySelector(`script[src*="googletagmanager.com/gtm.js?id=${GTM_ID}"]`)) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    script.async = true;
    document.head.appendChild(script);
  }, []);

  return null;
}
